import { useBreadcrumbs, type BreadcrumbItem } from '@/features/_hooks/use-breadcrumbs'
import { useIsRouteActive } from '@/features/_hooks/use-is-route-active'
import type { TExposedCompanyDTO } from '@doutorsim/shared/companies'
import { PageHeader } from '../../../_components/ui/page-header'

interface TabConfig {
  showPersons?: boolean
  showUsers?: boolean
  showSettings?: boolean
}

interface CompanyHeaderProps {
  company: TExposedCompanyDTO
  backHref?: string
  breadcrumbs: BreadcrumbItem[]
  tabs?: TabConfig
}

export const CompanyHeader = ({
  company,
  backHref,
  breadcrumbs,
  tabs: tabConfig = {},
}: CompanyHeaderProps) => {
  const isFacilityRouteActive = useIsRouteActive('companies', 'facilities')
  const isPersonRouteActive = useIsRouteActive('companies', 'persons')
  const isUsersRouteActive = useIsRouteActive('companies', 'users')
  const isSettingsRouteActive = useIsRouteActive('companies', 'settings')

  useBreadcrumbs(breadcrumbs)

  const base = `/companies/${company.slug}`

  return (
    <PageHeader
      title={company.name}
      backHref={backHref}
      tabs={[
        {
          label: 'Unidades',
          href: `${base}/facilities`,
          isActive: isFacilityRouteActive,
        },
        {
          label: 'Pacientes',
          href: `${base}/persons`,
          isActive: isPersonRouteActive,
          hidden: !tabConfig.showPersons,
        },
        {
          label: 'Usuários',
          href: `${base}/users`,
          isActive: isUsersRouteActive,
          hidden: !tabConfig.showUsers,
        },
        {
          label: 'Configurações',
          href: `${base}/settings`,
          isActive: isSettingsRouteActive,
          hidden: !tabConfig.showSettings,
        },
      ]}
    />
  )
}
